const initialState = {
    responseConciliationsList: [],
    responseConciliations: [],
    responseCommentsConciliations: [],
    errorConciliations: false,
    errorCommentsConciliations: false,
    errorCreateComments: false,

    responseResumeConciliationsList: [],
    responseResumeConciliationById: [],
    responseEditResumeConciliation: [],
    responseCreateResumeConciliation: [],
    responseDeleteResumeConciliation: [],
    errorResumeConciliations: false,
    errorResumeConciliationById: false,
    errorEditResumeConciliation: false,
    errorCreateResumeConciliation: false,
    errorDeleteResumeConciliation: false,
    errorDeleteTransactionTypeName: false,
    errorDeleteTransactionTypeNameMessage: '',
    errorDeleteTransactionItemName: false,
    errorDeleteTransactionItemNameMessage: '',

    responseFileUpload: [],
    errorFileUpload: false,

    responseManualConciliation: [],
    errorManualConciliation: false,

    responseFilteredConciliation: [],
    errorFilteredConciliations: false,

    responseExportConciliation: [],
    errorExportConciliations: false,

    responseRevertConciliation: [],
    errorRevertConciliation: false,

    responseExtractDownload: [],
    errorResponseExtractDownload: false,

    responseCheckReportCobranzasConciliacion: [],
    errorCheckReportCobranzasConciliacion: false,
    responseTransactionSummary: [],
    errorTransactionSummary: false,

    responseTransactionTypeNameList: [],
    errorTransactionTypeNameList: false,
    responseTransactionTypeName: [],

    responseTransactionItemBankNameList: [],
    errorTransactionItemBankNameList: false,
    responseTransactionItemSpertaNameList: [],
    errorTransactionItemSpertaNameList: false,
    responseTransactionItemName: [],

    responseDeleteTransactionTypeName: [],
    responseDeleteTransactionItemName: [],
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "DELETE_CONCILIATION_RESUME":
            newState.responseDeleteResumeConciliation = action.value;
            if (action.value.detail !== undefined) {
                newState.errorDeleteResumeConciliation = false;
            } else {
                newState.errorDeleteResumeConciliation = true;
            }
            break;
        case "CONCILIATION_RESUME_BY_ID":
            newState.responseResumeConciliationById = action.value;
            if (action.value.detail !== undefined) {
                newState.errorResumeConciliationById = false;
            } else {
                newState.errorResumeConciliationById = true;
            }
            break;
        case "EDIT_CONCILIATION_RESUME":
            newState.responseEditResumeConciliation = action.value;
            if (action.value.status !== undefined) {
                newState.errorEditResumeConciliation = true;
            } else {
                newState.errorEditResumeConciliation = false;
            }
            break;
        case "CREATE_CONCILIATION_RESUME":
            newState.responseCreateResumeConciliation = action.value;
            if (action.value.status !== undefined) {
                newState.errorCreateResumeConciliation = true;
            } else {
                newState.errorCreateResumeConciliation = false;
            }
            break;
        case "CONCILIATIONS_RESUME_LIST":
            newState.responseResumeConciliationsList = action.value;
            if (action.value.detail !== undefined) {
                newState.errorResumeConciliations = true;
            } else {
                newState.errorResumeConciliations = false;
            }
            break;
        case "CONCILIATIONS_RESPONSE_LIST":
            newState.responseConciliationsList = action.value;
            if (action.value.detail !== undefined) {
                newState.errorConciliations = true;
            } else {
                newState.errorConciliations = false;
            }
            //newState.responseCONSOLIDATION = []
            break;
        case "CONCILIATION_RESPONSE":
            newState.responseConciliations = action.value;
            if (action.value !== undefined) {
                newState.errorConciliations = true;
            } else {
                newState.errorConciliations = false;
            }
            break;
        case "CONCILIATION_COMMENTS_RESPONSE":
            newState.responseCommentsConciliations = action.value;
            if (action.value !== undefined) {
                newState.errorCommentsConciliations = true;
            } else {
                newState.errorCommentsConciliations = false;
            }
            break;
        case "CREATE_COMMENTS_RESPONSE":
            newState.responseCommentsConciliations = action.value;
            if (action.value !== undefined) {
                newState.errorCreateComments = true;
            } else {
                newState.errorCreateComments = false;
            }
            break;
        case "RESPONSE_MANUAL_CONCILIATION":
            if (action.value !== undefined) {
                if (action.value.error) {
                    newState.responseManualConciliation = action.value;
                    newState.errorManualConciliation = true;
                } else {
                    newState.responseManualConciliation = action.value;
                    newState.errorManualConciliation = false;
                }
            } else {
                newState.responseManualConciliation = [];
                newState.errorManualConciliation = true;
            }
            break;
        case "RESPONSE_REVERT_CONCILIATION":
            if (action.value !== undefined) {
                if (action.value.error) {
                    newState.responseRevertConciliation = action.value;
                    newState.errorRevertConciliation = true;
                } else {
                    newState.responseRevertConciliation = action.value;
                    newState.errorRevertConciliation = false;
                }
            } else {
                newState.responseRevertConciliation = [];
                newState.errorRevertConciliation = true;
            }
            break;

        case "RESPONSE_TRANSACTION_SUMMARY":
            if (action.value !== undefined) {
                if (action.value.status === 'error') {
                    newState.responseTransactionSummary = action.value;
                    newState.errorTransactionSummary = true;
                } else {
                    newState.responseTransactionSummary = action.value;
                    newState.errorTransactionSummary = false;
                }
            } else {
                newState.responseTransactionSummary = [];
                newState.errorTransactionSummary = true;
            }
            break;


        case "FILE_RESPONSE_CONCILIATIONS":
            if (action.value !== undefined) {
                if (action.value.error) {
                    newState.responseFileUpload = action.value;
                    newState.errorFileUpload = true;
                } else {
                    newState.responseFileUpload = action.value;
                    newState.errorFileUpload = false;
                }
            } else {
                newState.responseFileUpload = [];
                newState.errorFileUpload = true;
            }
            break;
        case "FILE_RESPONSE_CONCILIATION_BILLING":
            if (action.value !== undefined) {
                if (action.value.status === 'error') {
                    newState.responseFileUpload = action.value;
                    newState.errorFileUpload = true;
                } else {
                    newState.responseFileUpload = action.value;
                    newState.errorFileUpload = false;
                }
            } else {
                newState.responseFileUpload = [];
                newState.errorFileUpload = true;
            }
            break;
        case "FILTERED_CONCILIATION_RESPONSE":
            newState.responseFilteredConciliation = action.value;
            if (action.value.error) {
                newState.errorFilteredConciliations = true;
            } else {
                newState.errorFilteredConciliations = false;
            }
            break;
        case "EXPORT_CONCILIATION_RESPONSE":
            newState.responseExportConciliation = action.value;
            if (action.value.error) {
                newState.errorExportConciliations = true;
            } else {
                newState.errorExportConciliations = false;
            }
            break;
        case "DOWNLOAD_EXTRACT_RESPONSE":
            newState.responseExtractDownload = action.value;
            if (action.value.status !== undefined) {
                newState.errorResponseExtractDownload = false;
            } else {
                newState.errorResponseExtractDownload = true;
            }
            break;
        case "REPORT_EXPORT_COBRANZAS_CONCILIACION_RESPONSE":
            newState.responseCheckReportCobranzasConciliacion = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReportCobranzasConciliacion = true;
            } else {
                newState.errorCheckReportCobranzasConciliacion = false;
            }
            break;
        case "TRANSACTIONTYPENAME_RESPONSE_LIST":
            if (action.value.detail !== undefined) {
                newState.responseTransactionTypeNameList = []
                newState.errorTransactionTypeNameList = true;
            } else {
                newState.responseTransactionTypeNameList = action.value;
                newState.errorTransactionTypeNameList = true;
            }
            break;
        case "TRANSACTIONTYPENAME_RESPONSE":
            newState.responseTransactionTypeName = action.value;
            break;
        case "TRANSACTIONITEMBANKNAME_RESPONSE_LIST":
            if (action.value.detail !== undefined) {
                newState.responseTransactionItemBankNameList = []
                newState.errorTransactionItemBankNameList = true;
            } else {
                newState.responseTransactionItemBankNameList = action.value;
                newState.errorTransactionItemBankNameList = true;
            }
            break;
        case "TRANSACTIONITEMSPERTANAME_RESPONSE_LIST":
            if (action.value.detail !== undefined) {
                newState.responseTransactionItemSpertaNameList = []
                newState.errorTransactionItemSpertaNameList = true;
            } else {
                newState.responseTransactionItemSpertaNameList = action.value;
                newState.errorTransactionItemSpertaNameList = true;
            }
            break;
        case "TRANSACTIONITEMNAME_RESPONSE":
            newState.responseTransactionItemName = action.value;
            break;
        case "DELETE_TRANSACTIONTYPENAME":
            if (action.value.status !== 204) {
                newState.errorDeleteTransactionTypeName = true;
                newState.responseDeleteTransactionTypeName = action.value;
                if (action.value.status === 409) {
                    newState.errorDeleteTransactionTypeNameMessage = 'No se puede eliminar este tipo de transacción porque hay registros asociados en TransactionSummaryConciliation';
                }
            } else {
                newState.errorDeleteTransactionTypeName = false;
                newState.responseDeleteTransactionTypeName = [];
            }
            break;
        case "DELETE_TRANSACTIONITEMNAME":
            if (action.value.status !== 204) {
                newState.errorDeleteTransactionItemName = true;
                newState.responseDeleteTransactionItemName = action.value;
                if (action.value.status === 409) {
                    newState.errorDeleteTransactionItemNameMessage = 'No se puede eliminar este item de la de transacción porque hay registros asociados en TransactionSummaryConciliation';
                }
            } else {
                newState.errorDeleteTransactionItemName = false;
                newState.responseDeleteTransactionItemName = [];
            }
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;